import React, {PureComponent} from 'react';
import ModalMulterCore from '@/components/feedback/scModalMulterCore';
import modalConfig from '@/modals_config/config';
import PropTypes from 'prop-types';
import {initModals} from "@/state/action/comAction";
import {hocAddProps} from "@/hoc/hocComponent";

class Demo extends PureComponent {
  constructor () {
    super();
    this.state = {
      modalConfig: null
    }
  }

  static contextTypes = {
    store: PropTypes.object.isRequired
  };

  componentWillMount () {
    const WriteForm = hocAddProps(modalConfig.writeModal.content, {
      uid: '1',
      layout: '1',
      formTarget: 'modal',
      openTarget: 'readModal'
    });
    const WriteForm1 = hocAddProps(modalConfig.readModal.content, {
      uid: '2',
      layout: '1',
      formTarget: 'modal',
      openTarget: 'readModal1'
    });
    modalConfig.writeModal.content = WriteForm;
    modalConfig.readModal.content = WriteForm1;
    this.modalConfig = [modalConfig.writeModal, modalConfig.readModal, modalConfig.readModal1];
  }

  openModal (key) {
    this.context.store.dispatch(initModals(key, '123'));
  }

  render () {
    return <div>
      <h2>多重modal</h2>
      <div onClick={() => {this.openModal('writeModal')}}>writeModal</div>
      <div onClick={() => {this.openModal('readModal')}}>readModal</div>
      <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
    </div>
  }
}

export default Demo;


// WEBPACK FOOTER //
// ./src/AntD/pages/example/multModal/demo.js